function isValidICXAddress(address, currency, networkType) {
    const regex = /^hx[0-9a-f]{40}$/g; // Begins with hx followed by 40 hex chars
    return address.search(regex) !== -1;
}

export default {
    isValidAddress(address, currency, networkType) {
        return isValidICXAddress(address, currency, networkType);
    },
};
